import React from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';

import { PAGE_DIRECTORY } from '../../../services/filter/constants';
import { cashbackDirectoryRoutes } from '../../../routes/directory';

import { clearFilter, clearSort } from '../../../services/filter/actions';

import { mapRoutes } from '../../../utils/routeUtils';

class CashbackDirectoryPage extends React.Component {
    componentDidUpdate(prevProps) {
        const { match } = this.props;
        if (match.params.type !== prevProps.match.params.type) {
            this.props.clearFilter();
        }
    }

    componentWillUnmount() {
        this.props.clearFilter(PAGE_DIRECTORY);
        this.props.clearSort(PAGE_DIRECTORY);
    }

    render() {
        return (
            <div>
                <Switch>{mapRoutes(cashbackDirectoryRoutes)}</Switch>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18nPage: state.i18n.page.DIRECTORY.CASHBACK
    };
};

const mapDispatchToProps = {
    clearFilter,
    clearSort
};

export default connect(mapStateToProps, mapDispatchToProps)(CashbackDirectoryPage);



// WEBPACK FOOTER //
// ./src/components/pages/directory/CashbackDirectoryPage.js